module.exports = __webpack_public_path__ + "assets/img/9ml.16c59997.svg";